import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useDispatch, useSelector} from 'react-redux';

import {SingleListElection} from 'features/election-single';
import ButtonWhatsApp from '../../shared/components/buttons/ButtonWhatsApp';
import {eSingleLoadPlatesAsync} from '../election-single/store/actions';
import {getESingleInfo} from '../election-single/store/selectors';
import EmptyElectionsSection from './components/EmptyElectionsSection';
import ListElection from './components/ListElection';

import Screen from './screen';
import {loadPlatesAsync} from './store/actions';
import {logoutAuthAsync} from '../auth/store/actions';
import {
  getElection,
  getElectionInfo,
  getPlatesClosed,
  getPlatesOpened,
} from './store/selectors';
import {IElection, IPlate} from './store/types';
import NoActiveElectionsDialog from './components/NoActiveElectionsDialog';

const Home: React.FC = () => {
  const {t} = useTranslation();
  const dispatch = useDispatch();

  const [singleElection, setSingleElection] = useState<boolean>(false);

  const electionDetail: IElection | null = useSelector(getElection);
  const elections: IPlate[] = useSelector(getPlatesOpened);
  const closedElections: IPlate[] = useSelector(getPlatesClosed);
  const electionInfo = useSelector(getElectionInfo);
  const eSingleInfo = useSelector(getESingleInfo);

  const hasOpenedElections = elections.length > 0;
  const hasClosedElections = closedElections.length > 0;
  const hasGeneralElections = elections.length + closedElections.length > 0;
  const [
    openedNoActiveElectionsDialog,
    setOpenedNoActiveElectionsDialog,
  ] = useState(false);

  useEffect(() => {
    dispatch(loadPlatesAsync.request());
  }, []);

  useEffect(() => {
    setSingleElection(
      !!electionDetail &&
        electionDetail.configs &&
        electionDetail.configs.enable_single_vote
    );
  }, [electionDetail]);

  useEffect(() => {
    if (singleElection && elections.length) {
      dispatch(eSingleLoadPlatesAsync.request(elections.map(p => p.uuid)));
    }

    if (!hasOpenedElections) {
      setOpenedNoActiveElectionsDialog(true);
    } else {
      setOpenedNoActiveElectionsDialog(false);
    }
  }, [elections, singleElection]);

  const closeConfirmDialog = (action: string) => {
    setOpenedNoActiveElectionsDialog(false);

    if (action === 'confirm') {
      dispatch(logoutAuthAsync.request());
    }
  };

  if (electionInfo.loading || eSingleInfo.loading) {
    return null;
  }

  return (
    <>
      <Screen
        className={
          hasGeneralElections ? 'home' : 'home screen-justify-start-padding'
        }
      >
        <h2 className="primary-title">{t('inicio.votacoes')}</h2>

        {/* ---- ESTADO: SEM ELEIÇÕES DISPONÍVEIS + config de redirect automático ----- */}
        {!hasOpenedElections &&
          electionDetail &&
          electionDetail.configs.enable_auto_logout && (
            <NoActiveElectionsDialog
              open={openedNoActiveElectionsDialog}
              onClose={closeConfirmDialog}
            />
          )}

        {/* ---- ESTADO: SEM ELEIÇÕES ATIVAS ----- */}
        {!hasOpenedElections && !hasClosedElections && (
          <EmptyElectionsSection />
        )}

        {/* ---- ESTADO: COM ELEIÇÕES ATIVAS -MULTIPAGE ELECTION ---- */}
        {hasOpenedElections && !singleElection && (
          <>
            <p className="default-subtitle mt-0 text-center">
              {t('inicio.faca-sua-escolha')}
            </p>
            <ListElection elections={elections || []} restrain={false} />
          </>
        )}

        {/* ---- ESTADO: COM ELEIÇÕES ATIVAS - SINGLE ELECTION ---- */}
        {hasOpenedElections && singleElection && (
          <>
            <SingleListElection />
          </>
        )}

        {hasClosedElections && (
          <>
            <h4 className="secondary-text title-voted-list">
              {t('inicio.votos-computados')}
            </h4>
            <ListElection
              className="old-list"
              elections={closedElections || []}
              restrain={true}
            />
          </>
        )}
      </Screen>
      <ButtonWhatsApp />
    </>
  );
};

export default Home;



// WEBPACK FOOTER //
// ./src/features/election/Home.tsx